<template>
	<section>
		<el-col :span="5" >
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Offers</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Offers', params:{ active:'first' }})">{{offers.open}} open offers</el-link></p>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Offers', params:{ active:'second' }})">{{offers.proposed}} proposed offers</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Inbound</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Inbound', params:{ active:'first' }})">{{inbound.inbound}} inbound items</el-link></p>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Inbound', params:{ active:'second' }})">{{inbound.reported}} reported item</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Outbound</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Outbound', params:{ active:'second' }})">{{outbound.outbound}} outbound shipments</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Payments</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Payments', params:{ active:'first' }})">{{balance.request}} Nurse payment request</el-link> for a total of ${{balance.requestTotal}}</p>
				</div>
				<div class="text item">
					<p>Balance: ${{balance.totalBalance}}</p>
					<p>Pending: ${{balance.totalPending}}</p>
				</div>
			</el-card>
		</el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import {getDoctorHome} from "../../api/securityService";

	export default {
		data() {
			return {
				offers:{
					open:0,
					proposed:0
				},
				inbound:{
					inbound:0,
					reported:0
				},
				outbound:{
					outbound:0
				},
				balance:{
					request:0,
					requestTotal:0,
					totalBalance:0,
					totalPending:0
				},
				loading:false
			}
		},
		methods: {
			getDoctorHome(){
				this.loading = true;
				getDoctorHome().then((data)=>{
					this.loading = false;
					if(data.status===200){
						this.offers.open = data.result.offerNum;
						this.offers.proposed = data.result.proposeNum;
						this.inbound.inbound = data.result.inboundNum;
						this.inbound.reported = data.result.reportNum;
						this.outbound.outbound = data.result.outboundNum;
						this.balance.request = data.result.paymentNum;
						this.balance.requestTotal = data.result.amount;
						this.balance.totalBalance = data.result.transactionAmount;
						this.balance.totalPending = data.result.pending;
					}else{
						this.$message.error(data.message);
					}
				})
			}
		},
		mounted() {
			this.getDoctorHome();
		}
	}

</script>


// WEBPACK FOOTER //
// overview.vue?0e047aab